import React from "react";
import { DateField, Labeled, ReferenceField, TextField } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { graduationRequests } from "api/graduationApi";
import { InternshipSessionField } from "server/components/Fields/InternshipSessionInput";

const ScheduleInfo = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <Grid
      container
      spacing={3}
      sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
    >
      <Grid
        item
        xs={12}
        md={4}
      >
        <Labeled label="Стажантска сесия">
          <InternshipSessionField />
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <Labeled label="Стажантски план">
          <ReferenceField
            source="planId"
            reference={graduationRequests.getInternshipPlansSelect()}
          >
            <TextField source="name" />
          </ReferenceField>
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <Labeled label="Дисциплина">
          <ReferenceField
            source="disciplineId"
            reference={administrationRequests.getDisciplinesSelect()}
          >
            <TextField source="name" />
          </ReferenceField>
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={2}
      >
        <Labeled label="От дата">
          <DateField
            source="fromDate"
            locales="bg-BG"
          />
        </Labeled>
      </Grid>
      <Grid
        item
        xs={12}
        md={2}
      >
        <Labeled label="До дата">
          <DateField
            source="toDate"
            locales="bg-BG"
          />
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default ScheduleInfo;
